import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, TextInput } from '@mantine/core';

import { mapGame } from './api/mapGame';
import { BASE_MAPPING_URL, ERROR_MESSAGES } from './constants';
import { useQueryClient } from '../../contexts/queryClient';

const MapGame = ({ slug, isDisabled }) => {
    const [inputValue, setInputValue] = useState('');
    const [inputError, setInputError] = useState('');

    const { queryClient } = useQueryClient();

    useEffect(() => {
        if (inputValue) {
            return;
        }

        setInputError('');
    }, [inputValue]);

    function handleChange(event) {
        const { value } = event.currentTarget;

        setInputValue(value);
    }

    async function handleMap() {
        if (!inputValue) {
            return;
        }

        const urlSegments = new URL(inputValue, document.baseURI).pathname.split('/');

        const slugStore = urlSegments.pop() || urlSegments.pop();

        try {
            await mapGame({ slug, slugStore });

            queryClient.invalidateQueries({ queryKey: [`${BASE_MAPPING_URL}${slug}/`] });

            setInputValue('');
        } catch (error) {
            const message = ERROR_MESSAGES[error.status] || 'Неизвестная ошибка';

            setInputError(message);
        }
    }

    return (
        <TextInput
            label="Связать с игрой Store"
            onChange={handleChange}
            value={inputValue}
            error={inputError}
            disabled={isDisabled}
            placeholder={isDisabled
                ? 'Сохраните текущую игру'
                : 'https://vkplay.ru/play/game/example/'}
            rightSection={(
                <ActionIcon
                    variant="filled"
                    color="blue"
                    onClick={handleMap}
                >
                    <FontAwesomeIcon size="sm" icon="link" />
                </ActionIcon>
            )}
        />
    );
};

export default MapGame;
